import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { MobileTasksComponent } from './mobile-tasks.component'

import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const mobileTasksRoutes: Routes = [
  {
    path: 'admin/tasks',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'MOBILE_TASKS',
        redirectTo: '/',
      },
    },
    children: [{ path: '', component: MobileTasksComponent }],
  },
]
